// @flow

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getDistance from '@turf/distance';
import bearing from '@turf/bearing';
import along from '@turf/along';
import { lineString } from '@turf/helpers';
import {
  selectLocus,
  selectSelected,
  selectFitBounds,
} from './modules/map';

type Props = {
  locus: any,
  selected: any,
  fitBounds: any,
}

type State = {
  position: null | {
    center: any,
    bearing: number,
    zoom: number,
    pitch: number,
  },
}

const minZoom = 7;
const maxZoom = 8;
const maxDistance = 140;
const minDistance = 70;

const pointFeature = ({ id, coordinates, ...properties }) => ({
  id,
  type: 'Feature',
  geometry: { type: 'Point', coordinates },
  properties,
});

class FlyToSelected extends Component<Props, State> {
  static contextTypes = {
    map: PropTypes.object.isRequired,
  };

  state = {
    position: null,
  }

  componentWillReceiveProps({ locus, fitBounds, selected }) {
    if (fitBounds && locus && selected !== this.props.selected) {
      if (selected) {
        const { map } = this.context;

        if (!this.props.selected) {
          this.setState({
            position: {
              center: map.getCenter(),
              bearing: map.getBearing(),
              zoom: map.getZoom(),
              pitch: map.getPitch(),
            },
          });
        }

        if (selected.coordinates && locus.geometry.coordinates) {
          map.flyTo(this.trajectory({ selected: pointFeature(selected), locus }));
        }
      } else if (this.props.selected) {
        this.context.map.flyTo(this.state.position);
        this.setState({ position: null });
      }
    }
  }

  trajectory = ({ selected, locus }) => {
    let distance = getDistance(selected, locus) / 4;
    distance = Math.min(distance, maxDistance);
    distance = Math.max(distance, minDistance);

    const percentExtraZoom = 1 - ((distance - minDistance) / (maxDistance - minDistance));
    const zoom = minZoom + (percentExtraZoom * (maxZoom - minZoom));

    const line = lineString([
      selected.geometry.coordinates,
      locus.geometry.coordinates,
    ]);

    return {
      center: along(line, distance).geometry.coordinates,
      bearing: bearing(selected, locus),
      zoom,
      pitch: 55,
    };
  }

  render = () => null
}

const mapStateToProps = state => ({
  locus: selectLocus(state),
  selected: selectSelected(state),
  fitBounds: selectFitBounds(state),
});

export default connect(
  mapStateToProps,
  null,
)(FlyToSelected);



// WEBPACK FOOTER //
// ./src/fly-to-selected.js